import React, { useState, useEffect } from 'react';
import { SuccessState } from '@/components/SuccessState';
import { useSendOffer } from '@/hooks/queries/usePoolQueries';
import { OfferType } from '@/types/offer';
import { PoolDetail } from '@/types/pool';
import { Modal } from '../../ui/Modal';
import { ModalTitle } from '../ModalTitle';
import { OfferFormStep } from './OfferFormStep';

type SendOfferModalProps = {
  pool: PoolDetail;
  isOpen: boolean;
  onClose: () => void;
};

export const SendOfferModal: React.FC<SendOfferModalProps> = ({ pool, isOpen, onClose }) => {
  const [showSuccess, setShowSuccess] = useState(false);

  const sendOfferMutation = useSendOffer();
  const isSubmitting = sendOfferMutation.isPending;
  const error = sendOfferMutation.error?.message;

  const handleSendOffer = async () => {
    try {
      await sendOfferMutation.mutateAsync({
        pool_id: pool.id,
        type: OfferType.OFFER,
      });
      setShowSuccess(true);
    } catch (error) {
      // Error is handled by the error state above
      console.error(error);
    }
  };

  const handleSuccessOk = () => {
    setShowSuccess(false);
    onClose();
  };

  // Reset success state when modal closes
  useEffect(() => {
    if (!isOpen) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setShowSuccess(false);
    }
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} width={760} header={<ModalTitle title="Offer to Fund this Pool" />}>
      {showSuccess ? (
        <SuccessState
          title="Offer Sent"
          message="Your offer to fund this pool has been sent successfully. The borrower has 72 hours to respond."
          onButtonClick={handleSuccessOk}
        />
      ) : (
        <OfferFormStep pool={pool} onSendOffer={handleSendOffer} isSubmitting={isSubmitting} error={error} />
      )}
    </Modal>
  );
};
